import * as React from "react";
import { logToAndylitics, logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

export default class VisitThrive extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.VisitThrive.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    logActivity() {
        logToAndylitics('MBHWeb.Thrive.Visit.Redirect', new Date(), this.props.thriveMainUrl);
    }

    render() {
        const { employeeLoggedIn, thriveMainUrl } = this.props;
        return (
            <div className="card visit-thrive">
                <div className="card-header">
                    <div className="row">
                        <div className="col-12">
                            <div className="card-heading">Be your better self more often.</div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <p>
                                Even if you can't be at your best all the time, what if you could have more energy,&nbsp;
                                stress less, or kick that not-so-great-for-you habit?&nbsp;
                            </p>
                            <p>
                                We'll help you build skills based on your goals, needs, and life to help improve your health.
                                {employeeLoggedIn ? '' : ' And you just may find you can be at your best more often.'}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="card-footer">
                    <div className="row">
                        <div className="col-12">
                            <a className="btn btn-primary" href={thriveMainUrl} target="_blank" onClick={() => this.logActivity()}>
                                Visit Thrive
                            </a>
                        </div>
                    </div>
                </div>
            </div >
        );
    }

}
